var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","x-small":"","color":"grey"},on:{"click":_vm.reload}},[_vm._v("Versão: 1.1.8")])}
var staticRenderFns = []

export { render, staticRenderFns }